import React, { useRef } from 'react';

import ModalVideo from '../ModalVideo';
import { MiguelTamara_Video3 } from '../../../../../utils/EN/Modals/aiArtists';

const ModalVideoMiguelTamara3 = () => {
  return (
    <>
      <ModalVideo
        id="miguel-tamara-video-3"
        dataText={MiguelTamara_Video3}
        videoSrc="https://www.youtube.com/embed/mtkSs7xWcRU"
        videoTitle="KUTER_STUDIO_AI_MIGUEL_TAMARA_VIDEO_3"
      />
    </>
  );
};

export default ModalVideoMiguelTamara3;
